import React, { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';

const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      setDeferredPrompt(e);
      // Update UI notify the user they can install the PWA
      setShowPrompt(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    // If app is already installed, hide it
    window.addEventListener('appinstalled', () => {
      setShowPrompt(false);
      setDeferredPrompt(null);
    });

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    // Show the install prompt
    deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    const { outcome } = await deferredPrompt.userChoice;
    console.log(`User response to the install prompt: ${outcome}`);
    // We've used the prompt, and can't use it again, throw it away
    setDeferredPrompt(null);
    setShowPrompt(false);
  };

  if (!showPrompt) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 md:bottom-6 md:left-auto md:right-6 md:w-96 z-50 animate-slide-in-up">
      <div className="glass-card p-4 shadow-2xl border-gold-500/30 flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl bg-gold-500/20 flex items-center justify-center shrink-0 border border-gold-500/30">
          <Download className="text-gold-400 w-6 h-6" />
        </div>
        <div className="flex-1">
          <h4 className="text-white font-bold text-sm">Install Realty Pro App</h4>
          <p className="text-gray-400 text-xs mt-1">Get faster access and notifications. Works offline.</p>
          <div className="flex gap-2 mt-3">
            <button 
              onClick={handleInstallClick}
              className="bg-gold-500 hover:bg-gold-400 text-navy-900 px-4 py-1.5 rounded-lg text-sm font-bold transition-colors"
            >
              Install
            </button>
            <button 
              onClick={() => setShowPrompt(false)}
              className="px-4 py-1.5 rounded-lg text-sm font-medium text-gray-400 hover:bg-white/10 transition-colors"
            >
              Maybe Later
            </button>
          </div>
        </div>
        <button onClick={() => setShowPrompt(false)} className="text-gray-500 hover:text-white">
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;
